import {createSlice} from "@reduxjs/toolkit";
import {TUserData, TUserInitialState} from "@/types/redux/userTypes";
import {TPixelStatus} from "@/types/pixelStatus/pixelStatusTypes";
import {fetchGetUser} from "@/redux/user/userActions";

const initialState: TUserInitialState = {
    userId: "",
    isLoadingUser: true,
    userData: {
        name: "",
        email: "",
        wallet: null,
        image: "",
    },
    pixelStatus: "notConnected",
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUserField: (state: TUserInitialState, {payload}) => {
            return {...state, ...payload};
        },
        setUserId: (state: TUserInitialState, {payload}: { payload: string }) => {
            state.userId = payload;
        },
        setUserDataAction: (
            state: TUserInitialState,
            {payload}: { payload: TUserData }
        ) => {
            state.userData = payload;
        },
        setPixelStatus: (
            state: TUserInitialState,
            {payload}: { payload: TPixelStatus }
        ) => {
            state.pixelStatus = payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchGetUser.pending, (state) => {
                state.isLoadingUser = true;
            })
            .addCase(fetchGetUser.fulfilled, (state, {payload}) => {
                state.isLoadingUser = false;
                if (payload) state.userData = payload.userData;
                if (payload) state.pixelStatus = payload.pixelStatus;
            })
    }
});

export const {setUserId, setUserDataAction, setUserField, setPixelStatus} =
    userSlice.actions;

export default userSlice.reducer;
